import { buildRechercheStore } from '../shared'
import type {
  RechercheQueryDossierRemboursementDTO,
  RechercheResultDossierRemboursementDTO,
} from '@/features/api/extranet/dto/Dossier/Recherche/Remboursements'
import type {
  RechercheQueryDemandeRemboursementDTO,
  RechercheResultDemandeRemboursementDTO,
} from '@/features/api/extranet/dto/Demande/Recherche/Remboursements'

export const API_PATH_DR_DEMANDES = '/remboursement/demandes'

export const useDRRechercheDemandeStore = buildRechercheStore<
  RechercheQueryDemandeRemboursementDTO,
  RechercheResultDemandeRemboursementDTO
>({
  storeName: 'rechercheDRDemandeStore',
  apiPath: API_PATH_DR_DEMANDES,
  location: {
    to: 'recherche',
    domaine: 'dr',
    module: 'demande'
  }
})

export const API_PATH_DR_DOSSIERS = '/remboursements'

// Todo: INT - A remplacer, quand Pierrick l'aura cablé
export const useDRRechercheDossierStore = buildRechercheStore<
  RechercheQueryDossierRemboursementDTO,
  RechercheResultDossierRemboursementDTO
>({
  storeName: 'rechercheDRDossierStore',
  apiPath: API_PATH_DR_DOSSIERS,
  location: {
    to: 'recherche',
    domaine: 'dr',
    module: 'dossier'
  }
})
